import { render, staticRenderFns } from "./UtUpload.vue?vue&type=template&id=138494e2&scoped=true"
import script from "./UtUpload.vue?vue&type=script&lang=js"
export * from "./UtUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138494e2",
  null
  
)

export default component.exports